import React from 'react'
import { useMediaQuery } from '@mui/material'

import Grid2 from '@mui/material/Unstable_Grid2' // Grid version 2
import { useNavigate } from 'react-router-dom'

import TitleRow from './TitleRow.js'

export default function GridTitleRow() {
    const navigate = useNavigate()
    const handlePgNav = () => {
        navigate({
            pathname: '/',
        })
    }

    const isBelow400 = useMediaQuery('(max-width: 399.95px)') // < 400px

    const label = isBelow400 ? '' : 'Material Listing Estimate'

    return (
        <Grid2 container columns={20}>
            <TitleRow handlePgNav={handlePgNav} titleText={label} />
        </Grid2>
    )
}
